/**
 * @Author: Klaudie <klaudie@foxprofi.cz>
 */

// API konfigurace
// V development módu používáme přímo backend URL
// V production módu se použije VITE_API_BASE_URL z .env
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

// LocalStorage klíče
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'menyxo_access_token',
  REFRESH_TOKEN: 'menyxo_refresh_token',
  USER_PROFILE: 'menyxo_user_profile',
} as const

// Časové konstanty
export const TOKEN_REFRESH_THRESHOLD = 120 // Obnovit token 2 minuty před expirací (v sekundách)

// Sidebar
export const SIDEBAR_WIDTH = {
  EXPANDED: 240,
  COLLAPSED: 64,
} as const
